module.exports = __webpack_public_path__ + "img/cover-jeu-06.64ed5134.png";